import { useEffect, useState } from 'react'
import { Switch } from 'antd'
import { creationEventStore } from 'state/event/eventCreationStore'

const DocumentToggle = () => {
  const { eventData, documentsApprovalRequired, setDocumentsApprovalRequired } =
    creationEventStore(store => ({
      eventData: store.eventData,
      documentsApprovalRequired: store.documentsApprovalRequired,
      setDocumentsApprovalRequired: store.setDocumentsApprovalRequired,
    }))
  const handleSwitch = (checked: boolean) => {
    setDocumentsApprovalRequired(checked)
  }

  useEffect(() => {
    setDocumentsApprovalRequired(eventData.documentsApprovalRequired)
    // setDocumentToggle(eventData.documentsApprovalRequired)
  }, [])

  return (
    <div className="flex align-center justify-between py-10px">
      <h3 className="w-500 text-16">Documents Approval</h3>
      <Switch
        checked={documentsApprovalRequired}
        onChange={e => handleSwitch(e)}
      />
    </div>
  )
}

export default DocumentToggle
